import React from 'react';
import { OfferBase } from "./offer-base";

export class RegistrationOffer extends OfferBase {
    id = "RegistrationOffer";
    analyticsCategory = "NotUsed";

    async shouldBeVisible(): Promise<boolean> {
        const cStatus = (await this.services.cmsSegmentation).isCstatus;    // can be null
        return this.services.playerOfferings.isRegistrationOfferEnabled &&
                !this.services.miniOrbit.isEnabled &&
                (cStatus === false) &&
                this.services.device.isMobile &&
                this.services.mediaQuery.portrait &&
                await super.shouldBeVisible();
    }
    
    shouldUseLinkToOfferAnimation(): boolean {
        return false;
    }

    isHighPriorityOffer(): boolean {
        return true;
    }

    render(): React.ReactNode {
        return null;
    }
}
